import styled, { css } from 'styled-components';
import { transparentize } from 'utils/color';
import * as typography from 'components/mixins/typography';
import media from 'components/mixins/media';
import buttonDefaultStyle from 'components/mixins/normalize';
import { transition } from 'components/mixins/interactivity';
import { defaultBoxShadowColor } from 'constants/common';

export const Wrapper = styled.div`
  text-align: center;
  ${transition('all', '0.3s')};

  ${props =>
    props.isImageLoading
      ? css`
          background-color: ${transparentize(props.theme.colors.ctaButtonColor, 0.02)};
          min-height: 60px;
        `
      : ''};
`;

export const ImageSpotsWrapper = styled.div`
  max-width: 100%;
  position: relative;
  display: inline-block;
  vertical-align: bottom;
`;

export const Image = styled.img`
  max-width: 100% !important;
  margin: 0 auto !important;
`;

export const Spots = styled.div`
  position: absolute;
  display: block;
  outline: none;
  width: ${props => (parseFloat(props.width) * 100 / parseFloat(props.naturalWidth)).toFixed(4)}%;
  height: ${props =>
    (parseFloat(props.height) * 100 / parseFloat(props.naturalHeight)).toFixed(4)}%;
  top: ${props => (parseFloat(props.top) * 100 / parseFloat(props.naturalHeight)).toFixed(4)}%;
  left: ${props => (parseFloat(props.left) * 100 / parseFloat(props.naturalWidth)).toFixed(4)}%;

  &:hover {
    background-color: ${props => transparentize(props.theme.colors.contentBodyColor, 0.1)};
    box-shadow: 0 0 20px 0 ${transparentize(defaultBoxShadowColor, 0.05)};

    button {
      background-color: ${props => props.theme.colors.contentBodyColor};
      animation: none;

      &::after {
        visibility: visible;
        background-color: ${props => transparentize(props.theme.colors.mainColor, 0.1)};
        ${transition('0.3s')};
      }
    }
  }

  &.active {
    background-color: ${props => transparentize(props.theme.colors.contentBodyColor, 0.1)};
    box-shadow: 0 0 20px 0 ${transparentize(defaultBoxShadowColor, 0.05)};

    button {
      animation: none;
      background-color: ${props => props.theme.colors.mainColor};
      ${transition('0.3s')};
      color: ${props => props.theme.colors.contentBodyColor};
    }
  }
`;

export const PopoverInfoButton = styled.div`
  ${buttonDefaultStyle};
  position: absolute;
  top: 50%;
  left: 50%;
  width: 36px;
  height: 36px;
  cursor: pointer;
  animation: pulse 1.5s infinite;
  transform: translate(-50%, -50%);
  padding: 0;
  border-radius: 50%;
  box-shadow: 0 2px 10px 0 ${transparentize(defaultBoxShadowColor, 0.1)};
  background-color: ${props => props.theme.colors.contentBodyColor};
  ${typography.mainFontSmallText};
  font-weight: bold;
  line-height: 36px;
  text-align: center;
  color: ${props => props.theme.colors.mainColor};

  &::after {
    visibility: hidden;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  &:hover,
  &:focus {
    background-color: ${props => props.theme.colors.contentBodyColor};
    animation: none;

    &.active {
      background-color: ${props => props.theme.colors.mainColor};
      ${transition('0.3s')};
      color: ${props => props.theme.colors.contentBodyColor};
    }

    &::after {
      visibility: visible;
      background-color: ${props => transparentize(props.theme.colors.mainColor, 0.1)};
      ${transition('0.3s')};
    }
  }

  ${media.mobile`
      width: 30px;
      height: 30px;
      font-size: 12px;
      line-height: 30px;
      animation: none;
  `};

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0px ${props => transparentize(props.theme.colors.contentBodyColor, 0.5)};
    }
    75% {
      box-shadow: 0 0 0 5px ${props => transparentize(props.theme.colors.contentBodyColor, 0.3)};
    }
    100% {
      box-shadow: 0 0 0 7px ${props => transparentize(props.theme.colors.contentBodyColor, 0.05)};
    }
  }
`;

export const PopoverContent = styled.div`
  overflow: auto;
  max-width: 292px;
  max-height: 362px;
  padding: 30px 30px 0;
  box-shadow: 0 2px 10px 0 ${transparentize(defaultBoxShadowColor, 0.1)};
  background-color: ${props => props.theme.colors.contentBodyColor};
  color: ${props => props.theme.colors.textColor};
  ${typography.mainFontSmallText};
  line-height: 30px;
  white-space: pre-line;

  &:before {
    content: '';
    display: block;
    position: absolute;
    margin: 0 auto;
    width: calc(100% - 60px);
    left: 0;
    right: 0;
    bottom: 6px;
    height: 10%;
    max-height: 30px;
    background: linear-gradient(
      to top,
      ${props => props.theme.colors.contentBodyColor},
      ${props => transparentize(props.theme.colors.contentBodyColor, 0.1)}
    );
  }

  &:after {
    content: '';
    display: block;
    position: relative;
    width: calc(100% - 12px);
    left: 5px;
    right: 5px;
    bottom: 0;
    height: 30px;
    max-height: 40px;
    background: ${props => props.theme.colors.contentBodyColor};
  }

  ${media.mobile`
    max-width: 252px;
    max-height: 200px;
    padding: 20px 20px 0;
    margin: 0 auto;

    &:before {
      width: calc(100% - 30px);
    }

    &:after {
      height: 20px;
      bottom: 6px;
    }
  `};
`;
